





























































import {Component, Vue} from 'vue-property-decorator';
import moment from 'moment';

import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import Datepicker from '@/components/datepicker/DatePicker.vue';
import api from '@/infrastructure/api/external/externalMovementApi';
import {取込履歴検索条件型} from '@/type/external/request/取込履歴検索条件';
import {取込履歴型} from '@/type/external/file/取込履歴';
import router from '@/router';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import 外部連携移動検索条件入力チェッカー from '@/type/external/validator/外部連携移動検索条件入力チェッカー';
import 外部連携取込履歴検索条件チェッカー from '@/type/external/validator/外部連携取込履歴検索条件チェッカー';
import {progress} from '@/script/progress';

@Component({
  components: {
    Datepicker,
    ButtonPanel,
    IconButton,
    AlertDialog,
  },
  filters: {
    日付フォーマット(date: Date): string | null {
      return moment(date).format('YYYY/MM/DD');
    },
  },
})
export default class ExternalCaptureList extends Vue {

  取込履歴検索条件: 取込履歴検索条件型 = {取込日From: moment().toDate(), 取込日To: null};
  取込履歴一覧: 取込履歴型[] = [];
  選択された履歴: 取込履歴型 | null = null;
  アラートメッセージ: string[] = [];
  checker: 外部連携取込履歴検索条件チェッカー | null = null;

  確定(): void {
    if (this.選択された履歴 == null) {
      return;
    }
    router.push({name: '外部連携取込', query: {fileSeq: String(this.選択された履歴.取込ファイル番号)}});
  }

  確定ボタンが非活性である(): boolean {
    return this.選択された履歴 == null;
  }

  選択する(取込履歴: 取込履歴型): void {
    this.選択された履歴 = 取込履歴;
  }

  選択行数(): number {
    if (this.選択された履歴 == null) return 0;
    return this.取込履歴一覧.indexOf(this.選択された履歴) + 1;
  }

  検索条件エラー判定(項目名: string): boolean {
    if (this.checker == null) return false;
    return this.checker.hasError(項目名);
  }

  async 取込履歴検索ハンドラ() {
    this.選択された履歴 = null;
    this.取込履歴一覧 = [];

    this.checker = new 外部連携取込履歴検索条件チェッカー(this.取込履歴検索条件);
    if (this.checker.hasErrors()) {
      this.アラートメッセージ = this.checker.errorMessages();
      this.$modal.show('アラート');
      return;
    }

    await progress(this.取込履歴検索);
  }

  async 取込履歴検索() {
    await api.取込履歴を検索する(this.取込履歴検索条件)
      .then((response: any) => {
        const 一覧 = response.一覧
          .map((it: any) => new 取込履歴型(it.取込ファイル番号, it.取込日時, it.ファイル名, it.取込状態));
        this.取込履歴一覧 = 一覧;
        if (this.取込履歴一覧.length === 0) {
          this.アラートメッセージ = ['条件に合致する外部連携取込履歴はありません'];
          this.$modal.show('アラート');
          return;
        }
        if (response.アラートメッセージ) {
          this.アラートメッセージ = [response.アラートメッセージ];
          this.$modal.show('アラート');
        }
      })
      .catch((error: any) => {
          if (error.data.errors) {
            this.アラートメッセージ = error.data.errors;
          }
          if (error.data.message && !error.data.errors) {
            this.アラートメッセージ = [error.data.message];
          }
          this.$modal.show('アラート');
      });
  }

  総件数(): number {
    return this.取込履歴一覧.length;
  }

  取込状態クラス(取込履歴: 取込履歴型): string {
    if (this.選択された履歴 === 取込履歴) {
      return 'selected';
    }
    if (取込履歴.取込状態 === '確定不可') {
      return '確定不可';
    }
    if (取込履歴.取込状態 === '未確定') {
      return '未確定';
    }
    return '';
  }
}
